/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration Layer (BOL) API
 * Business Orchestration layer (BOL) API. Public part, exposed to BOL client applications.  Glossary | Definition -- | -- <strong>Logistics Object</strong> | A resource in the BOL system that represents a business entity, such as a QuotationRequest, Quotation, or Service. Logistics Objects are managed through the BOL API and can be accessed or modified by Users based on their permissions i.e. based on their AD Entra ID roles and ACL (Access Control List) modes. <strong>Member</strong> | A data owner in the BOL system, uniquely identified by its `memberIdentifier`. Members are used to manage access control and ownership of Logistics Objects. <strong>User</strong> | A person or entity that interacts with the BOL system, typically through a client application, and beeing authenticated. Users are associated with Members and can perform actions on Logistics Objects based on their access level. User access token includes the Member identifier as part of roles claims. Each path in the API is protected by a custom role defined in AD Entra ID, and operations on Logistics Objects are protected by specific Access modes defined by members. <strong>Access Control</strong> | The mechanism by which the BOL system restricts access to API paths and resources based on the identity of the User and their associated Member. Access control is enforced through AD Entra ID roles and ACL (Access Control List) modes defined for every single Logistics Object. <strong>ACL (Access Control List)</strong> | A set of authorizations that define what actions a User can perform on a Logistics Object. The level of access granted to Users is determined by ACL modes defined in authorizations for specific Logistics Objects. ACL Modes are not directly associated with Users but rather with Members, which are the data owners of Logistics Objects. Each Logistics Object has an ACL that specifies the access modes for different Members. Members need to exist in the BOL system to be granted access to Logistics Objects. <strong>ACL Mode</strong> | The specific level of access control applied to a Logistics Object, determining what actions can be performed by Users. ACL modes are defined for each Logistics Object by `memberIdentifier` and include `READ`, `WRITE`, and `CONTROL`. Each mode includes access granted by the modes under it, so `CONTROL` includes `WRITE` and `READ`, and `WRITE` includes `READ`. <strong>Change Request</strong> | A request to modify a Logistics Object, which is processed by the BOL system. Change requests are created when a User wants to update an existing Logistics Object, and they are subject to approval and application by the system. All changes to Logistics Objects are done through change requests. This allows for a controlled and auditable process of modifications. <strong>Host</strong> | A server alias in the BOL system, used to abstract URI values internally. This allows for flexibility in the underlying infrastructure when migrating or changing server configurations. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ACL,
  ACLAuthorization,
  ACLAuthorizationRequest,
  ChangeRequest,
  ChangeRequestCreateRequest,
  ChangeRequestPatchRequest,
  ErrorResponse,
  EventCreateRequest,
  InvoicingDocument,
  InvoicingDocumentResponse,
  LogisticsObjectMetadata,
  PaginatedChangeRequests,
  PaginatedEvents,
  SearchInvoicingDocumentsRequest,
  SearchInvoicingDocumentsResponse,
} from '../models/index';
import {
    ACLFromJSON,
    ACLToJSON,
    ACLAuthorizationFromJSON,
    ACLAuthorizationToJSON,
    ACLAuthorizationRequestFromJSON,
    ACLAuthorizationRequestToJSON,
    ChangeRequestFromJSON,
    ChangeRequestToJSON,
    ChangeRequestCreateRequestFromJSON,
    ChangeRequestCreateRequestToJSON,
    ChangeRequestPatchRequestFromJSON,
    ChangeRequestPatchRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    EventCreateRequestFromJSON,
    EventCreateRequestToJSON,
    InvoicingDocumentFromJSON,
    InvoicingDocumentToJSON,
    InvoicingDocumentResponseFromJSON,
    InvoicingDocumentResponseToJSON,
    LogisticsObjectMetadataFromJSON,
    LogisticsObjectMetadataToJSON,
    PaginatedChangeRequestsFromJSON,
    PaginatedChangeRequestsToJSON,
    PaginatedEventsFromJSON,
    PaginatedEventsToJSON,
    SearchInvoicingDocumentsRequestFromJSON,
    SearchInvoicingDocumentsRequestToJSON,
    SearchInvoicingDocumentsResponseFromJSON,
    SearchInvoicingDocumentsResponseToJSON,
} from '../models/index';

export interface CreateChangeRequestOnInvoicingDocumentByIdRequest {
    invoicingDocumentId: string;
    contentType: CreateChangeRequestOnInvoicingDocumentByIdContentTypeEnum;
    changeRequestCreateRequest: ChangeRequestCreateRequest;
    source?: boolean;
    accept?: CreateChangeRequestOnInvoicingDocumentByIdAcceptEnum;
    traceparent?: string;
}

export interface CreateInvoicingDocumentRequest {
    contentType: CreateInvoicingDocumentContentTypeEnum;
    xBOLMemberIdentifier: string;
    invoicingDocument: InvoicingDocument;
    id?: string;
    source?: boolean;
    accept?: CreateInvoicingDocumentAcceptEnum;
    traceparent?: string;
    xBOLACLAuthorizations?: string;
}

export interface CreateInvoicingDocumentEventRequest {
    invoicingDocumentId: string;
    contentType: CreateInvoicingDocumentEventContentTypeEnum;
    xBOLMemberIdentifier: string;
    eventCreateRequest: EventCreateRequest;
    accept?: CreateInvoicingDocumentEventAcceptEnum;
    traceparent?: string;
}

export interface DeleteInvoicingDocumentACLAuthorizationByMemberIdRequest {
    invoicingDocumentId: string;
    memberId: string;
    xBOLMemberIdentifier: string;
    aclRevision?: string;
    traceparent?: string;
}

export interface DeleteInvoicingDocumentByIdRequest {
    invoicingDocumentId: string;
    traceparent?: string;
}

export interface DeleteInvoicingDocumentEventByIdRequest {
    invoicingDocumentId: string;
    eventId: string;
    xBOLMemberIdentifier: string;
    traceparent?: string;
}

export interface GetChangeRequestOnInvoicingDocumentByIdRequest {
    invoicingDocumentId: string;
    changeRequestId: string;
    accept?: GetChangeRequestOnInvoicingDocumentByIdAcceptEnum;
    traceparent?: string;
}

export interface GetInvoicingDocumentACLAuthorizationByMemberIdRequest {
    invoicingDocumentId: string;
    memberId: string;
    at?: string;
    aclRevision?: string;
    accept?: GetInvoicingDocumentACLAuthorizationByMemberIdAcceptEnum;
    traceparent?: string;
}

export interface GetInvoicingDocumentACLByIdRequest {
    invoicingDocumentId: string;
    at?: string;
    revision?: string;
    accept?: GetInvoicingDocumentACLByIdAcceptEnum;
    traceparent?: string;
}

export interface GetInvoicingDocumentByIdRequest {
    invoicingDocumentId: string;
    at?: string;
    revision?: string;
    accept?: GetInvoicingDocumentByIdAcceptEnum;
    traceparent?: string;
}

export interface GetInvoicingDocumentEventsRequest {
    invoicingDocumentId: string;
    limit?: number;
    offset?: number;
    startAt?: Date;
    endAt?: Date;
    code?: string;
    type?: string;
    accept?: GetInvoicingDocumentEventsAcceptEnum;
    traceparent?: string;
}

export interface GetInvoicingDocumentMetadataByIdRequest {
    invoicingDocumentId: string;
    accept?: GetInvoicingDocumentMetadataByIdAcceptEnum;
    traceparent?: string;
}

export interface ListChangeRequestsOfInvoicingDocumentByIdRequest {
    invoicingDocumentId: string;
    limit?: number;
    offset?: number;
    accept?: ListChangeRequestsOfInvoicingDocumentByIdAcceptEnum;
    traceparent?: string;
}

export interface PatchInvoicingDocumentByIdRequest {
    invoicingDocumentId: string;
    contentType: PatchInvoicingDocumentByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    invoicingDocument: InvoicingDocument;
    revision?: string;
    accept?: PatchInvoicingDocumentByIdAcceptEnum;
    traceparent?: string;
}

export interface SearchInvoicingDocumentGetRequest {
    id?: string;
    searchBody?: SearchInvoicingDocumentsRequest;
    accept?: SearchInvoicingDocumentGetAcceptEnum;
    traceparent?: string;
}

export interface SearchInvoicingDocumentsPostRequest {
    contentType: SearchInvoicingDocumentsPostContentTypeEnum;
    searchInvoicingDocumentsRequest: SearchInvoicingDocumentsRequest;
    limit?: number;
    offset?: number;
    accept?: SearchInvoicingDocumentsPostAcceptEnum;
    traceparent?: string;
}

export interface UpdateChangeRequestOnInvoicingDocumentByIdRequest {
    invoicingDocumentId: string;
    changeRequestId: string;
    contentType: UpdateChangeRequestOnInvoicingDocumentByIdContentTypeEnum;
    changeRequestPatchRequest: ChangeRequestPatchRequest;
    accept?: UpdateChangeRequestOnInvoicingDocumentByIdAcceptEnum;
    traceparent?: string;
}

export interface UpdateInvoicingDocumentByIdRequest {
    invoicingDocumentId: string;
    contentType: UpdateInvoicingDocumentByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    invoicingDocument: InvoicingDocument;
    revision?: string;
    accept?: UpdateInvoicingDocumentByIdAcceptEnum;
    traceparent?: string;
}

export interface UpsertInvoicingDocumentACLAuthorizationByIdRequest {
    invoicingDocumentId: string;
    contentType: UpsertInvoicingDocumentACLAuthorizationByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    aclRevision?: string;
    accept?: UpsertInvoicingDocumentACLAuthorizationByIdAcceptEnum;
    traceparent?: string;
    aCLAuthorizationRequest?: ACLAuthorizationRequest;
}

/**
 * 
 */
export class LogisticsObjectsInvoicingDocumentsApi extends runtime.BaseAPI {

    /**
     * ## Description  This endpoint allows the creation of a change request on a specific InvoicingDocument resource, identified by its `InvoicingDocumentId`.  The change request uses the JSON Patch format as specified in [RFC 6902](https://datatracker.ietf.org/doc/html/rfc6902), enabling clients to submit a set of operations to modify the InvoicingDocument resource.  Client uers must have the provided `requestorMemberIdentifier` as part of their own member identifiers.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode or above is required to create a change request on a InvoicingDocument resource.   - **Note**: The `WRITE` mode is sufficient for creating change requests, but higher modes like `CONTROL` or `Admin` can also be used.   - With `CONTROL` mode, the change request will be automatically accepted and applied, updating the InvoicingDocument resource.   - With `WRITE` mode, the change request will be created but not applied automatically. The change request must then be accepted or rejected using the `PATCH` method on the change request resource. 
     * Create a change request on a InvoicingDocument
     */
    async createChangeRequestOnInvoicingDocumentByIdRaw(requestParameters: CreateChangeRequestOnInvoicingDocumentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['invoicingDocumentId'] == null) {
            throw new runtime.RequiredError(
                'invoicingDocumentId',
                'Required parameter "invoicingDocumentId" was null or undefined when calling createChangeRequestOnInvoicingDocumentById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createChangeRequestOnInvoicingDocumentById().'
            );
        }

        if (requestParameters['changeRequestCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'changeRequestCreateRequest',
                'Required parameter "changeRequestCreateRequest" was null or undefined when calling createChangeRequestOnInvoicingDocumentById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/invoicing-documents/{invoicingDocumentId}/change-requests`;
        urlPath = urlPath.replace(`{${"invoicingDocumentId"}}`, encodeURIComponent(String(requestParameters['invoicingDocumentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeRequestCreateRequestToJSON(requestParameters['changeRequestCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows the creation of a change request on a specific InvoicingDocument resource, identified by its `InvoicingDocumentId`.  The change request uses the JSON Patch format as specified in [RFC 6902](https://datatracker.ietf.org/doc/html/rfc6902), enabling clients to submit a set of operations to modify the InvoicingDocument resource.  Client uers must have the provided `requestorMemberIdentifier` as part of their own member identifiers.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode or above is required to create a change request on a InvoicingDocument resource.   - **Note**: The `WRITE` mode is sufficient for creating change requests, but higher modes like `CONTROL` or `Admin` can also be used.   - With `CONTROL` mode, the change request will be automatically accepted and applied, updating the InvoicingDocument resource.   - With `WRITE` mode, the change request will be created but not applied automatically. The change request must then be accepted or rejected using the `PATCH` method on the change request resource. 
     * Create a change request on a InvoicingDocument
     */
    async createChangeRequestOnInvoicingDocumentById(requestParameters: CreateChangeRequestOnInvoicingDocumentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest | null | undefined > {
        const response = await this.createChangeRequestOnInvoicingDocumentByIdRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 201:
                return null;
            case 200:
                return await response.value();
            default:
                return await response.value();
        }
    }

    /**
     * ## Description  This endpoint allows the creation of a new InvoicingDocument.  When creating a InvoicingDocument, the value of the header `X-BOL-Member-Identifier` defines the InvoicingDocument\'s owner. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  When creating a InvoicingDocument, its ACL (Access Control List) is initialized with a default set of authorizations. The ACL defines which Members have access to the InvoicingDocument and what actions they can perform.  By default, the ACL is initialized with access for the Member that creates the InvoicingDocument, granting it `CONTROL` access mode. This means that the Member can manage the ACL and perform any operation on the InvoicingDocument.  It is possible to use the header `X-BOL-ACL-authorizations` to specify additional authorizations for the ACL on initialization. The header must contain a JSON array of authorizations to apply in addition to the default one.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Create`. 
     * Create a InvoicingDocument
     */
    async createInvoicingDocumentRaw(requestParameters: CreateInvoicingDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoicingDocumentResponse>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createInvoicingDocument().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling createInvoicingDocument().'
            );
        }

        if (requestParameters['invoicingDocument'] == null) {
            throw new runtime.RequiredError(
                'invoicingDocument',
                'Required parameter "invoicingDocument" was null or undefined when calling createInvoicingDocument().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (requestParameters['xBOLACLAuthorizations'] != null) {
            headerParameters['X-BOL-ACL-authorizations'] = String(requestParameters['xBOLACLAuthorizations']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/invoicing-documents`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvoicingDocumentToJSON(requestParameters['invoicingDocument']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoicingDocumentResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows the creation of a new InvoicingDocument.  When creating a InvoicingDocument, the value of the header `X-BOL-Member-Identifier` defines the InvoicingDocument\'s owner. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  When creating a InvoicingDocument, its ACL (Access Control List) is initialized with a default set of authorizations. The ACL defines which Members have access to the InvoicingDocument and what actions they can perform.  By default, the ACL is initialized with access for the Member that creates the InvoicingDocument, granting it `CONTROL` access mode. This means that the Member can manage the ACL and perform any operation on the InvoicingDocument.  It is possible to use the header `X-BOL-ACL-authorizations` to specify additional authorizations for the ACL on initialization. The header must contain a JSON array of authorizations to apply in addition to the default one.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Create`. 
     * Create a InvoicingDocument
     */
    async createInvoicingDocument(requestParameters: CreateInvoicingDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoicingDocumentResponse | null | undefined > {
        const response = await this.createInvoicingDocumentRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 201:
                return null;
            case 200:
                return await response.value();
            default:
                return await response.value();
        }
    }

    /**
     * ## Description  Create an Event of a InvoicingDocument by `invoicingDocumentId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode is required to create an event on a InvoicingDocument resource. 
     * Create an Event of a InvoicingDocument
     */
    async createInvoicingDocumentEventRaw(requestParameters: CreateInvoicingDocumentEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['invoicingDocumentId'] == null) {
            throw new runtime.RequiredError(
                'invoicingDocumentId',
                'Required parameter "invoicingDocumentId" was null or undefined when calling createInvoicingDocumentEvent().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createInvoicingDocumentEvent().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling createInvoicingDocumentEvent().'
            );
        }

        if (requestParameters['eventCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'eventCreateRequest',
                'Required parameter "eventCreateRequest" was null or undefined when calling createInvoicingDocumentEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/invoicing-documents/{invoicingDocumentId}/events`;
        urlPath = urlPath.replace(`{${"invoicingDocumentId"}}`, encodeURIComponent(String(requestParameters['invoicingDocumentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventCreateRequestToJSON(requestParameters['eventCreateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  Create an Event of a InvoicingDocument by `invoicingDocumentId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode is required to create an event on a InvoicingDocument resource. 
     * Create an Event of a InvoicingDocument
     */
    async createInvoicingDocumentEvent(requestParameters: CreateInvoicingDocumentEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createInvoicingDocumentEventRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific authorization from the Access Control List (ACL) of a InvoicingDocument resource for a given member, identified by the `memberId`. This removes the access granted to the specified member for the Logistics Object.  - When an ACL authorization is deleted, the member will lose access to the InvoicingDocument resource according to the authorization that was removed. - This operation should be performed with caution as it affects access control to the resource. - The requesting user must have sufficient privileges to modify the ACL.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to delete authorizations from the ACL of a InvoicingDocument resource. 
     * Delete an authorization of an access control list of a InvoicingDocument by memberId
     */
    async deleteInvoicingDocumentACLAuthorizationByMemberIdRaw(requestParameters: DeleteInvoicingDocumentACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['invoicingDocumentId'] == null) {
            throw new runtime.RequiredError(
                'invoicingDocumentId',
                'Required parameter "invoicingDocumentId" was null or undefined when calling deleteInvoicingDocumentACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling deleteInvoicingDocumentACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling deleteInvoicingDocumentACLAuthorizationByMemberId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/invoicing-documents/{invoicingDocumentId}/acl/authorizations/{memberId}`;
        urlPath = urlPath.replace(`{${"invoicingDocumentId"}}`, encodeURIComponent(String(requestParameters['invoicingDocumentId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific authorization from the Access Control List (ACL) of a InvoicingDocument resource for a given member, identified by the `memberId`. This removes the access granted to the specified member for the Logistics Object.  - When an ACL authorization is deleted, the member will lose access to the InvoicingDocument resource according to the authorization that was removed. - This operation should be performed with caution as it affects access control to the resource. - The requesting user must have sufficient privileges to modify the ACL.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to delete authorizations from the ACL of a InvoicingDocument resource. 
     * Delete an authorization of an access control list of a InvoicingDocument by memberId
     */
    async deleteInvoicingDocumentACLAuthorizationByMemberId(requestParameters: DeleteInvoicingDocumentACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteInvoicingDocumentACLAuthorizationByMemberIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific InvoicingDocument resource, identified by its `InvoicingDocumentId`.  - When a InvoicingDocument is deleted, it is permanently removed from the system and cannot be recovered. This operation should be performed with caution. - Deletion of a InvoicingDocument resource is allowed even if the resource is referenced by any other resources or if the references are also deleted. - Deleting a InvoicingDocument resource also deletes any associated change requests and metadata, including the ACL and authorizations, as well as all Logistics Object Events.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Delete`. - **ACL Mode**: `CONTROL` mode is required to delete a InvoicingDocument resource. 
     * Delete a InvoicingDocument by invoicingDocumentId
     */
    async deleteInvoicingDocumentByIdRaw(requestParameters: DeleteInvoicingDocumentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['invoicingDocumentId'] == null) {
            throw new runtime.RequiredError(
                'invoicingDocumentId',
                'Required parameter "invoicingDocumentId" was null or undefined when calling deleteInvoicingDocumentById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/invoicing-documents/{invoicingDocumentId}`;
        urlPath = urlPath.replace(`{${"invoicingDocumentId"}}`, encodeURIComponent(String(requestParameters['invoicingDocumentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific InvoicingDocument resource, identified by its `InvoicingDocumentId`.  - When a InvoicingDocument is deleted, it is permanently removed from the system and cannot be recovered. This operation should be performed with caution. - Deletion of a InvoicingDocument resource is allowed even if the resource is referenced by any other resources or if the references are also deleted. - Deleting a InvoicingDocument resource also deletes any associated change requests and metadata, including the ACL and authorizations, as well as all Logistics Object Events.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Delete`. - **ACL Mode**: `CONTROL` mode is required to delete a InvoicingDocument resource. 
     * Delete a InvoicingDocument by invoicingDocumentId
     */
    async deleteInvoicingDocumentById(requestParameters: DeleteInvoicingDocumentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteInvoicingDocumentByIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific event of a InvoicingDocument resource by its `eventId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role \'BOL.LOGISTICS-OBJECTS.Update\'. - **ACL Mode**: `CONTROL` mode is required to delete an event of a InvoicingDocument resource. 
     * Delete an event of a InvoicingDocument by id
     */
    async deleteInvoicingDocumentEventByIdRaw(requestParameters: DeleteInvoicingDocumentEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['invoicingDocumentId'] == null) {
            throw new runtime.RequiredError(
                'invoicingDocumentId',
                'Required parameter "invoicingDocumentId" was null or undefined when calling deleteInvoicingDocumentEventById().'
            );
        }

        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling deleteInvoicingDocumentEventById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling deleteInvoicingDocumentEventById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/invoicing-documents/{invoicingDocumentId}/events/{eventId}`;
        urlPath = urlPath.replace(`{${"invoicingDocumentId"}}`, encodeURIComponent(String(requestParameters['invoicingDocumentId'])));
        urlPath = urlPath.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters['eventId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific event of a InvoicingDocument resource by its `eventId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role \'BOL.LOGISTICS-OBJECTS.Update\'. - **ACL Mode**: `CONTROL` mode is required to delete an event of a InvoicingDocument resource. 
     * Delete an event of a InvoicingDocument by id
     */
    async deleteInvoicingDocumentEventById(requestParameters: DeleteInvoicingDocumentEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteInvoicingDocumentEventByIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  Retrieves a specific ChangeRequest associated with a given InvoicingDocument, identified by its `changeRequestId`. This endpoint allows clients to access the details and status of a particular change request, including the set of modifications proposed or applied to the InvoicingDocument resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the details of a ChangeRequest resource. 
     * Get a change request on a InvoicingDocument by changeRequestId
     */
    async getChangeRequestOnInvoicingDocumentByIdRaw(requestParameters: GetChangeRequestOnInvoicingDocumentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['invoicingDocumentId'] == null) {
            throw new runtime.RequiredError(
                'invoicingDocumentId',
                'Required parameter "invoicingDocumentId" was null or undefined when calling getChangeRequestOnInvoicingDocumentById().'
            );
        }

        if (requestParameters['changeRequestId'] == null) {
            throw new runtime.RequiredError(
                'changeRequestId',
                'Required parameter "changeRequestId" was null or undefined when calling getChangeRequestOnInvoicingDocumentById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/invoicing-documents/{invoicingDocumentId}/change-requests/{changeRequestId}`;
        urlPath = urlPath.replace(`{${"invoicingDocumentId"}}`, encodeURIComponent(String(requestParameters['invoicingDocumentId'])));
        urlPath = urlPath.replace(`{${"changeRequestId"}}`, encodeURIComponent(String(requestParameters['changeRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a specific ChangeRequest associated with a given InvoicingDocument, identified by its `changeRequestId`. This endpoint allows clients to access the details and status of a particular change request, including the set of modifications proposed or applied to the InvoicingDocument resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the details of a ChangeRequest resource. 
     * Get a change request on a InvoicingDocument by changeRequestId
     */
    async getChangeRequestOnInvoicingDocumentById(requestParameters: GetChangeRequestOnInvoicingDocumentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest> {
        const response = await this.getChangeRequestOnInvoicingDocumentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves a specific authorization from the Access Control List (ACL) of a InvoicingDocument resource for a given member, identified by the `memberId`. This allows clients to check the specific access mode granted to a particular member for the Logistics Object.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL authorization of a InvoicingDocument resource. - **Note**: Only the `CONTROL` mode allows to get any member authorization. In `READ`, `WRITE` modes, only the authorization for the authenticated member user can be retrieved. 
     * Get an authorization of an access control list of a InvoicingDocument by memberId
     */
    async getInvoicingDocumentACLAuthorizationByMemberIdRaw(requestParameters: GetInvoicingDocumentACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACLAuthorization>> {
        if (requestParameters['invoicingDocumentId'] == null) {
            throw new runtime.RequiredError(
                'invoicingDocumentId',
                'Required parameter "invoicingDocumentId" was null or undefined when calling getInvoicingDocumentACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling getInvoicingDocumentACLAuthorizationByMemberId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/invoicing-documents/{invoicingDocumentId}/acl/authorizations/{memberId}`;
        urlPath = urlPath.replace(`{${"invoicingDocumentId"}}`, encodeURIComponent(String(requestParameters['invoicingDocumentId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLAuthorizationFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves a specific authorization from the Access Control List (ACL) of a InvoicingDocument resource for a given member, identified by the `memberId`. This allows clients to check the specific access mode granted to a particular member for the Logistics Object.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL authorization of a InvoicingDocument resource. - **Note**: Only the `CONTROL` mode allows to get any member authorization. In `READ`, `WRITE` modes, only the authorization for the authenticated member user can be retrieved. 
     * Get an authorization of an access control list of a InvoicingDocument by memberId
     */
    async getInvoicingDocumentACLAuthorizationByMemberId(requestParameters: GetInvoicingDocumentACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACLAuthorization> {
        const response = await this.getInvoicingDocumentACLAuthorizationByMemberIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves the Access Control List (ACL) for a specific InvoicingDocument resource, identified by its `InvoicingDocumentId`. The ACL details the authorizations for the authenticated member user.  This endpoint enables clients to review which members have access to the InvoicingDocument and under which access modes, supporting fine-grained authorization.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL of a InvoicingDocument resource. - **Note**: Only the `CONTROL` mode allows to get the Logistics Object ACL with all authorizations. In `READ`, `WRITE`, `READ` mode, the ACL will only contain authorizations for the authenticated member user. 
     * Get ACL of a InvoicingDocument for the authenticated member user. The ACL with the latest revision is returned by default.
     */
    async getInvoicingDocumentACLByIdRaw(requestParameters: GetInvoicingDocumentACLByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACL>> {
        if (requestParameters['invoicingDocumentId'] == null) {
            throw new runtime.RequiredError(
                'invoicingDocumentId',
                'Required parameter "invoicingDocumentId" was null or undefined when calling getInvoicingDocumentACLById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/invoicing-documents/{invoicingDocumentId}/acl`;
        urlPath = urlPath.replace(`{${"invoicingDocumentId"}}`, encodeURIComponent(String(requestParameters['invoicingDocumentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves the Access Control List (ACL) for a specific InvoicingDocument resource, identified by its `InvoicingDocumentId`. The ACL details the authorizations for the authenticated member user.  This endpoint enables clients to review which members have access to the InvoicingDocument and under which access modes, supporting fine-grained authorization.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL of a InvoicingDocument resource. - **Note**: Only the `CONTROL` mode allows to get the Logistics Object ACL with all authorizations. In `READ`, `WRITE`, `READ` mode, the ACL will only contain authorizations for the authenticated member user. 
     * Get ACL of a InvoicingDocument for the authenticated member user. The ACL with the latest revision is returned by default.
     */
    async getInvoicingDocumentACLById(requestParameters: GetInvoicingDocumentACLByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACL> {
        const response = await this.getInvoicingDocumentACLByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves a specific InvoicingDocument by its `InvoicingDocumentId`.  __Note:__ The `revision` and `at` query parameters cannot be used at the same time. If both are provided simultaneously, the request will result in a `Bad Request` error.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this InvoicingDocument resource. 
     * Get a InvoicingDocument by invoicingDocumentId
     */
    async getInvoicingDocumentByIdRaw(requestParameters: GetInvoicingDocumentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoicingDocumentResponse>> {
        if (requestParameters['invoicingDocumentId'] == null) {
            throw new runtime.RequiredError(
                'invoicingDocumentId',
                'Required parameter "invoicingDocumentId" was null or undefined when calling getInvoicingDocumentById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/invoicing-documents/{invoicingDocumentId}`;
        urlPath = urlPath.replace(`{${"invoicingDocumentId"}}`, encodeURIComponent(String(requestParameters['invoicingDocumentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoicingDocumentResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves a specific InvoicingDocument by its `InvoicingDocumentId`.  __Note:__ The `revision` and `at` query parameters cannot be used at the same time. If both are provided simultaneously, the request will result in a `Bad Request` error.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this InvoicingDocument resource. 
     * Get a InvoicingDocument by invoicingDocumentId
     */
    async getInvoicingDocumentById(requestParameters: GetInvoicingDocumentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoicingDocumentResponse> {
        const response = await this.getInvoicingDocumentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  List Events of a InvoicingDocument by `invoicingDocumentId`, ordered by their `actualDateTime`, from newest to oldest. Events are returned in a paginated format.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the events of a InvoicingDocument resource. 
     * List Events of a InvoicingDocument
     */
    async getInvoicingDocumentEventsRaw(requestParameters: GetInvoicingDocumentEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedEvents>> {
        if (requestParameters['invoicingDocumentId'] == null) {
            throw new runtime.RequiredError(
                'invoicingDocumentId',
                'Required parameter "invoicingDocumentId" was null or undefined when calling getInvoicingDocumentEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['startAt'] != null) {
            queryParameters['startAt'] = requestParameters['startAt'];
        }

        if (requestParameters['endAt'] != null) {
            queryParameters['endAt'] = requestParameters['endAt'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/invoicing-documents/{invoicingDocumentId}/events`;
        urlPath = urlPath.replace(`{${"invoicingDocumentId"}}`, encodeURIComponent(String(requestParameters['invoicingDocumentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedEventsFromJSON(jsonValue));
    }

    /**
     * ## Description  List Events of a InvoicingDocument by `invoicingDocumentId`, ordered by their `actualDateTime`, from newest to oldest. Events are returned in a paginated format.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the events of a InvoicingDocument resource. 
     * List Events of a InvoicingDocument
     */
    async getInvoicingDocumentEvents(requestParameters: GetInvoicingDocumentEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedEvents> {
        const response = await this.getInvoicingDocumentEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves the metadata of a specific InvoicingDocument by its `InvoicingDocumentId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this resource. 
     * Get a InvoicingDocument metadata by invoicingDocumentId
     */
    async getInvoicingDocumentMetadataByIdRaw(requestParameters: GetInvoicingDocumentMetadataByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogisticsObjectMetadata>> {
        if (requestParameters['invoicingDocumentId'] == null) {
            throw new runtime.RequiredError(
                'invoicingDocumentId',
                'Required parameter "invoicingDocumentId" was null or undefined when calling getInvoicingDocumentMetadataById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/invoicing-documents/{invoicingDocumentId}/metadata`;
        urlPath = urlPath.replace(`{${"invoicingDocumentId"}}`, encodeURIComponent(String(requestParameters['invoicingDocumentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogisticsObjectMetadataFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves the metadata of a specific InvoicingDocument by its `InvoicingDocumentId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this resource. 
     * Get a InvoicingDocument metadata by invoicingDocumentId
     */
    async getInvoicingDocumentMetadataById(requestParameters: GetInvoicingDocumentMetadataByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogisticsObjectMetadata> {
        const response = await this.getInvoicingDocumentMetadataByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a list of all change requests associated with the specified InvoicingDocument, identified by its `InvoicingDocumentId`. This endpoint allows clients to review the history of change requests (such as updates or modifications) that have been submitted for a given InvoicingDocument resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of change requests for a InvoicingDocument resource. 
     * Get a list of ChangeRequest for InvoicingDocument
     */
    async listChangeRequestsOfInvoicingDocumentByIdRaw(requestParameters: ListChangeRequestsOfInvoicingDocumentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedChangeRequests>> {
        if (requestParameters['invoicingDocumentId'] == null) {
            throw new runtime.RequiredError(
                'invoicingDocumentId',
                'Required parameter "invoicingDocumentId" was null or undefined when calling listChangeRequestsOfInvoicingDocumentById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/invoicing-documents/{invoicingDocumentId}/change-requests`;
        urlPath = urlPath.replace(`{${"invoicingDocumentId"}}`, encodeURIComponent(String(requestParameters['invoicingDocumentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedChangeRequestsFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a list of all change requests associated with the specified InvoicingDocument, identified by its `InvoicingDocumentId`. This endpoint allows clients to review the history of change requests (such as updates or modifications) that have been submitted for a given InvoicingDocument resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of change requests for a InvoicingDocument resource. 
     * Get a list of ChangeRequest for InvoicingDocument
     */
    async listChangeRequestsOfInvoicingDocumentById(requestParameters: ListChangeRequestsOfInvoicingDocumentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedChangeRequests> {
        const response = await this.listChangeRequestsOfInvoicingDocumentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows updating an existing InvoicingDocument identified by its `InvoicingDocumentId` using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). The patch operation applies partial updates to the resource. The underlying mechanism is the creation of a change-request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a InvoicingDocument resource. 
     * Partially update a InvoicingDocument by applying a JSON Merge Patch change request
     */
    async patchInvoicingDocumentByIdRaw(requestParameters: PatchInvoicingDocumentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoicingDocumentResponse>> {
        if (requestParameters['invoicingDocumentId'] == null) {
            throw new runtime.RequiredError(
                'invoicingDocumentId',
                'Required parameter "invoicingDocumentId" was null or undefined when calling patchInvoicingDocumentById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling patchInvoicingDocumentById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling patchInvoicingDocumentById().'
            );
        }

        if (requestParameters['invoicingDocument'] == null) {
            throw new runtime.RequiredError(
                'invoicingDocument',
                'Required parameter "invoicingDocument" was null or undefined when calling patchInvoicingDocumentById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/invoicing-documents/{invoicingDocumentId}`;
        urlPath = urlPath.replace(`{${"invoicingDocumentId"}}`, encodeURIComponent(String(requestParameters['invoicingDocumentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: InvoicingDocumentToJSON(requestParameters['invoicingDocument']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoicingDocumentResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows updating an existing InvoicingDocument identified by its `InvoicingDocumentId` using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). The patch operation applies partial updates to the resource. The underlying mechanism is the creation of a change-request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a InvoicingDocument resource. 
     * Partially update a InvoicingDocument by applying a JSON Merge Patch change request
     */
    async patchInvoicingDocumentById(requestParameters: PatchInvoicingDocumentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoicingDocumentResponse> {
        const response = await this.patchInvoicingDocumentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a paginated list of InvoicingDocument resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on InvoicingDocuments.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of InvoicingDocument resources. 
     * Search for InvoicingDocuments
     */
    async searchInvoicingDocumentGetRaw(requestParameters: SearchInvoicingDocumentGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchInvoicingDocumentsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['searchBody'] != null) {
            queryParameters['searchBody'] = requestParameters['searchBody'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/invoicing-documents/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchInvoicingDocumentsResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a paginated list of InvoicingDocument resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on InvoicingDocuments.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of InvoicingDocument resources. 
     * Search for InvoicingDocuments
     */
    async searchInvoicingDocumentGet(requestParameters: SearchInvoicingDocumentGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchInvoicingDocumentsResponse> {
        const response = await this.searchInvoicingDocumentGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a paginated list of InvoicingDocument resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on InvoicingDocuments.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of InvoicingDocument resources. 
     * Search for InvoicingDocuments
     */
    async searchInvoicingDocumentsPostRaw(requestParameters: SearchInvoicingDocumentsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchInvoicingDocumentsResponse>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling searchInvoicingDocumentsPost().'
            );
        }

        if (requestParameters['searchInvoicingDocumentsRequest'] == null) {
            throw new runtime.RequiredError(
                'searchInvoicingDocumentsRequest',
                'Required parameter "searchInvoicingDocumentsRequest" was null or undefined when calling searchInvoicingDocumentsPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/invoicing-documents/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchInvoicingDocumentsRequestToJSON(requestParameters['searchInvoicingDocumentsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchInvoicingDocumentsResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a paginated list of InvoicingDocument resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on InvoicingDocuments.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of InvoicingDocument resources. 
     * Search for InvoicingDocuments
     */
    async searchInvoicingDocumentsPost(requestParameters: SearchInvoicingDocumentsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchInvoicingDocumentsResponse> {
        const response = await this.searchInvoicingDocumentsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows you to accept or reject a specific ChangeRequest associated with a given InvoicingDocument, using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). It enables clients to update the status or details of a ChangeRequest, such as marking it as accepted or rejected, and to apply partial modifications to the resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Write`. - **ACL Mode**: `CONTROL` mode is required to accept or reject a ChangeRequest on a InvoicingDocument resource. 
     * Accept or reject a ChangeRequest on a  InvoicingDocument using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396).
     */
    async updateChangeRequestOnInvoicingDocumentByIdRaw(requestParameters: UpdateChangeRequestOnInvoicingDocumentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['invoicingDocumentId'] == null) {
            throw new runtime.RequiredError(
                'invoicingDocumentId',
                'Required parameter "invoicingDocumentId" was null or undefined when calling updateChangeRequestOnInvoicingDocumentById().'
            );
        }

        if (requestParameters['changeRequestId'] == null) {
            throw new runtime.RequiredError(
                'changeRequestId',
                'Required parameter "changeRequestId" was null or undefined when calling updateChangeRequestOnInvoicingDocumentById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling updateChangeRequestOnInvoicingDocumentById().'
            );
        }

        if (requestParameters['changeRequestPatchRequest'] == null) {
            throw new runtime.RequiredError(
                'changeRequestPatchRequest',
                'Required parameter "changeRequestPatchRequest" was null or undefined when calling updateChangeRequestOnInvoicingDocumentById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/invoicing-documents/{invoicingDocumentId}/change-requests/{changeRequestId}`;
        urlPath = urlPath.replace(`{${"invoicingDocumentId"}}`, encodeURIComponent(String(requestParameters['invoicingDocumentId'])));
        urlPath = urlPath.replace(`{${"changeRequestId"}}`, encodeURIComponent(String(requestParameters['changeRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeRequestPatchRequestToJSON(requestParameters['changeRequestPatchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows you to accept or reject a specific ChangeRequest associated with a given InvoicingDocument, using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). It enables clients to update the status or details of a ChangeRequest, such as marking it as accepted or rejected, and to apply partial modifications to the resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Write`. - **ACL Mode**: `CONTROL` mode is required to accept or reject a ChangeRequest on a InvoicingDocument resource. 
     * Accept or reject a ChangeRequest on a  InvoicingDocument using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396).
     */
    async updateChangeRequestOnInvoicingDocumentById(requestParameters: UpdateChangeRequestOnInvoicingDocumentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest> {
        const response = await this.updateChangeRequestOnInvoicingDocumentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows updating an existing InvoicingDocument identified by its `InvoicingDocumentId`. The underlying mechanism is the creation of a change request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a InvoicingDocument resource. 
     * Update an existing InvoicingDocument by creating and applying a change request
     */
    async updateInvoicingDocumentByIdRaw(requestParameters: UpdateInvoicingDocumentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoicingDocumentResponse>> {
        if (requestParameters['invoicingDocumentId'] == null) {
            throw new runtime.RequiredError(
                'invoicingDocumentId',
                'Required parameter "invoicingDocumentId" was null or undefined when calling updateInvoicingDocumentById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling updateInvoicingDocumentById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling updateInvoicingDocumentById().'
            );
        }

        if (requestParameters['invoicingDocument'] == null) {
            throw new runtime.RequiredError(
                'invoicingDocument',
                'Required parameter "invoicingDocument" was null or undefined when calling updateInvoicingDocumentById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/invoicing-documents/{invoicingDocumentId}`;
        urlPath = urlPath.replace(`{${"invoicingDocumentId"}}`, encodeURIComponent(String(requestParameters['invoicingDocumentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InvoicingDocumentToJSON(requestParameters['invoicingDocument']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoicingDocumentResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows updating an existing InvoicingDocument identified by its `InvoicingDocumentId`. The underlying mechanism is the creation of a change request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a InvoicingDocument resource. 
     * Update an existing InvoicingDocument by creating and applying a change request
     */
    async updateInvoicingDocumentById(requestParameters: UpdateInvoicingDocumentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoicingDocumentResponse> {
        const response = await this.updateInvoicingDocumentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows clients to create or update an authorization in the Access Control List (ACL) of a specific InvoicingDocument resource, identified by its `InvoicingDocumentId`.  If an authorization already exists for the given `memberIdentifier`, then this authorization is replaced by this requested new authorization.  The value of the header `X-BOL-Member-Identifier` defines the member that authorized the access. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to add or update authorizations in the ACL of a InvoicingDocument resource. 
     * Upsert (create or update) an authorization of an access control list of a InvoicingDocument.
     */
    async upsertInvoicingDocumentACLAuthorizationByIdRaw(requestParameters: UpsertInvoicingDocumentACLAuthorizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACLAuthorization>> {
        if (requestParameters['invoicingDocumentId'] == null) {
            throw new runtime.RequiredError(
                'invoicingDocumentId',
                'Required parameter "invoicingDocumentId" was null or undefined when calling upsertInvoicingDocumentACLAuthorizationById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling upsertInvoicingDocumentACLAuthorizationById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling upsertInvoicingDocumentACLAuthorizationById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/invoicing-documents/{invoicingDocumentId}/acl/authorizations`;
        urlPath = urlPath.replace(`{${"invoicingDocumentId"}}`, encodeURIComponent(String(requestParameters['invoicingDocumentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ACLAuthorizationRequestToJSON(requestParameters['aCLAuthorizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLAuthorizationFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows clients to create or update an authorization in the Access Control List (ACL) of a specific InvoicingDocument resource, identified by its `InvoicingDocumentId`.  If an authorization already exists for the given `memberIdentifier`, then this authorization is replaced by this requested new authorization.  The value of the header `X-BOL-Member-Identifier` defines the member that authorized the access. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to add or update authorizations in the ACL of a InvoicingDocument resource. 
     * Upsert (create or update) an authorization of an access control list of a InvoicingDocument.
     */
    async upsertInvoicingDocumentACLAuthorizationById(requestParameters: UpsertInvoicingDocumentACLAuthorizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACLAuthorization> {
        const response = await this.upsertInvoicingDocumentACLAuthorizationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CreateChangeRequestOnInvoicingDocumentByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateChangeRequestOnInvoicingDocumentByIdContentTypeEnum = typeof CreateChangeRequestOnInvoicingDocumentByIdContentTypeEnum[keyof typeof CreateChangeRequestOnInvoicingDocumentByIdContentTypeEnum];
/**
 * @export
 */
export const CreateChangeRequestOnInvoicingDocumentByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateChangeRequestOnInvoicingDocumentByIdAcceptEnum = typeof CreateChangeRequestOnInvoicingDocumentByIdAcceptEnum[keyof typeof CreateChangeRequestOnInvoicingDocumentByIdAcceptEnum];
/**
 * @export
 */
export const CreateInvoicingDocumentContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateInvoicingDocumentContentTypeEnum = typeof CreateInvoicingDocumentContentTypeEnum[keyof typeof CreateInvoicingDocumentContentTypeEnum];
/**
 * @export
 */
export const CreateInvoicingDocumentAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateInvoicingDocumentAcceptEnum = typeof CreateInvoicingDocumentAcceptEnum[keyof typeof CreateInvoicingDocumentAcceptEnum];
/**
 * @export
 */
export const CreateInvoicingDocumentEventContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateInvoicingDocumentEventContentTypeEnum = typeof CreateInvoicingDocumentEventContentTypeEnum[keyof typeof CreateInvoicingDocumentEventContentTypeEnum];
/**
 * @export
 */
export const CreateInvoicingDocumentEventAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateInvoicingDocumentEventAcceptEnum = typeof CreateInvoicingDocumentEventAcceptEnum[keyof typeof CreateInvoicingDocumentEventAcceptEnum];
/**
 * @export
 */
export const GetChangeRequestOnInvoicingDocumentByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetChangeRequestOnInvoicingDocumentByIdAcceptEnum = typeof GetChangeRequestOnInvoicingDocumentByIdAcceptEnum[keyof typeof GetChangeRequestOnInvoicingDocumentByIdAcceptEnum];
/**
 * @export
 */
export const GetInvoicingDocumentACLAuthorizationByMemberIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetInvoicingDocumentACLAuthorizationByMemberIdAcceptEnum = typeof GetInvoicingDocumentACLAuthorizationByMemberIdAcceptEnum[keyof typeof GetInvoicingDocumentACLAuthorizationByMemberIdAcceptEnum];
/**
 * @export
 */
export const GetInvoicingDocumentACLByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetInvoicingDocumentACLByIdAcceptEnum = typeof GetInvoicingDocumentACLByIdAcceptEnum[keyof typeof GetInvoicingDocumentACLByIdAcceptEnum];
/**
 * @export
 */
export const GetInvoicingDocumentByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetInvoicingDocumentByIdAcceptEnum = typeof GetInvoicingDocumentByIdAcceptEnum[keyof typeof GetInvoicingDocumentByIdAcceptEnum];
/**
 * @export
 */
export const GetInvoicingDocumentEventsAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetInvoicingDocumentEventsAcceptEnum = typeof GetInvoicingDocumentEventsAcceptEnum[keyof typeof GetInvoicingDocumentEventsAcceptEnum];
/**
 * @export
 */
export const GetInvoicingDocumentMetadataByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetInvoicingDocumentMetadataByIdAcceptEnum = typeof GetInvoicingDocumentMetadataByIdAcceptEnum[keyof typeof GetInvoicingDocumentMetadataByIdAcceptEnum];
/**
 * @export
 */
export const ListChangeRequestsOfInvoicingDocumentByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type ListChangeRequestsOfInvoicingDocumentByIdAcceptEnum = typeof ListChangeRequestsOfInvoicingDocumentByIdAcceptEnum[keyof typeof ListChangeRequestsOfInvoicingDocumentByIdAcceptEnum];
/**
 * @export
 */
export const PatchInvoicingDocumentByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchInvoicingDocumentByIdContentTypeEnum = typeof PatchInvoicingDocumentByIdContentTypeEnum[keyof typeof PatchInvoicingDocumentByIdContentTypeEnum];
/**
 * @export
 */
export const PatchInvoicingDocumentByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchInvoicingDocumentByIdAcceptEnum = typeof PatchInvoicingDocumentByIdAcceptEnum[keyof typeof PatchInvoicingDocumentByIdAcceptEnum];
/**
 * @export
 */
export const SearchInvoicingDocumentGetAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchInvoicingDocumentGetAcceptEnum = typeof SearchInvoicingDocumentGetAcceptEnum[keyof typeof SearchInvoicingDocumentGetAcceptEnum];
/**
 * @export
 */
export const SearchInvoicingDocumentsPostContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchInvoicingDocumentsPostContentTypeEnum = typeof SearchInvoicingDocumentsPostContentTypeEnum[keyof typeof SearchInvoicingDocumentsPostContentTypeEnum];
/**
 * @export
 */
export const SearchInvoicingDocumentsPostAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchInvoicingDocumentsPostAcceptEnum = typeof SearchInvoicingDocumentsPostAcceptEnum[keyof typeof SearchInvoicingDocumentsPostAcceptEnum];
/**
 * @export
 */
export const UpdateChangeRequestOnInvoicingDocumentByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateChangeRequestOnInvoicingDocumentByIdContentTypeEnum = typeof UpdateChangeRequestOnInvoicingDocumentByIdContentTypeEnum[keyof typeof UpdateChangeRequestOnInvoicingDocumentByIdContentTypeEnum];
/**
 * @export
 */
export const UpdateChangeRequestOnInvoicingDocumentByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateChangeRequestOnInvoicingDocumentByIdAcceptEnum = typeof UpdateChangeRequestOnInvoicingDocumentByIdAcceptEnum[keyof typeof UpdateChangeRequestOnInvoicingDocumentByIdAcceptEnum];
/**
 * @export
 */
export const UpdateInvoicingDocumentByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateInvoicingDocumentByIdContentTypeEnum = typeof UpdateInvoicingDocumentByIdContentTypeEnum[keyof typeof UpdateInvoicingDocumentByIdContentTypeEnum];
/**
 * @export
 */
export const UpdateInvoicingDocumentByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateInvoicingDocumentByIdAcceptEnum = typeof UpdateInvoicingDocumentByIdAcceptEnum[keyof typeof UpdateInvoicingDocumentByIdAcceptEnum];
/**
 * @export
 */
export const UpsertInvoicingDocumentACLAuthorizationByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpsertInvoicingDocumentACLAuthorizationByIdContentTypeEnum = typeof UpsertInvoicingDocumentACLAuthorizationByIdContentTypeEnum[keyof typeof UpsertInvoicingDocumentACLAuthorizationByIdContentTypeEnum];
/**
 * @export
 */
export const UpsertInvoicingDocumentACLAuthorizationByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpsertInvoicingDocumentACLAuthorizationByIdAcceptEnum = typeof UpsertInvoicingDocumentACLAuthorizationByIdAcceptEnum[keyof typeof UpsertInvoicingDocumentACLAuthorizationByIdAcceptEnum];
